import React from 'react';
import UserByType from './A_Components/UserByType';
import UsersByReferralSource from './A_Components/UserByRefferalSource';
import JobStats from './A_Components/JobsStats';


const Reports = () => {
    return (
        <div className='bg-white pr-2 '>
            <div>
                <UserByType />
            </div>
            <div className='mt-5'>
                <UsersByReferralSource />
            </div>
            <div className='mt-5'>
                <JobStats/>
            </div>

        </div>
    );
}

export default Reports;
